import React from 'react';
import { FiArrowUpRight, FiArrowDownRight } from "react-icons/fi";
import CopyableValue from '../common/CopyableValue';
import FitText from '../common/FitText';

const EffectiveMetric = ({ label, value, subValue, isPositive }) => {
  const arrow = isPositive ? (
    <FiArrowUpRight className="text-emerald-500" />
  ) : (
    <FiArrowDownRight className="text-crimson-500" />
  );

  return (
    <div className="self-start">
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 border-l border-white/10" />
        <div className="pl-6">
          <div className="text-slate-500 uppercase tracking-wider text-sm font-medium mb-1">{label}</div>
          <div className="text-slate-300/90 font-bold text-2xl mb-0.5 flex items-center gap-1">
            <FitText>
              <CopyableValue
                value={value}
                label={label}
                preserveFormatting
                className={value === '--' || value === '--x' ? 'dashes' : ''}
                afterElement={arrow}
              >
                {value}
              </CopyableValue>
            </FitText>
          </div>
          <div className="text-slate-500 text-sm tracking-wide">
            <FitText>
              <CopyableValue
                value={subValue}
                label={`${label} (Sub)`}
                preserveFormatting
                className={subValue.includes('--') ? 'dashes' : ''}
                size="small"
              >
                {subValue}
              </CopyableValue>
            </FitText>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EffectiveMetric;